import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  min-height: 100vh;
  padding: 110px 32px 48px;
  background: ${p => p.theme.palette.colors.background};

  @media(max-width: 700px) { padding: 96px 16px 32px; }
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  max-width: 1080px;
  margin: 0 auto 24px;

  @media(max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const Title = styled.h1`
  margin: 4px 0 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 38px;

  @media(max-width: 600px) { font-size: 32px; }
`

export const Subtitle = styled.p`
  margin: 0;
  color: ${p => p.theme.palette.colors.muted};
  font-family: Lato;
`

export const StatusBadge = styled.span`
  padding: 7px 14px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 999px;
  background: ${p => p.status === 'approved' ? p.theme.palette.colors.successMuted : p.status === 'rejected' ? p.theme.palette.colors.warningMuted : p.theme.palette.colors.badgeMuted};
  color: ${p => p.status === 'approved' ? p.theme.palette.success.main : p.status === 'rejected' ? p.theme.palette.error.main : p.theme.palette.blue.main};
  font-weight: 700;
  text-transform: capitalize;
`

export const DetailCard = styled.section`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 28px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
`

export const ReviewSection = styled.section`
  padding: 28px 0;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};

  &:last-child { border-bottom: 0; }
`

export const SectionHeading = styled.h2`
  margin: 0 0 18px;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 23px;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  @media(max-width: 700px) { grid-template-columns: 1fr; }
`

export const DetailItem = styled.div`
  min-width: 0;
  padding-right: 18px;
`

export const DetailLabel = styled.div`
  margin-bottom: 5px;
  color: ${p => p.theme.palette.colors.muted};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`

export const DetailValue = styled.div`
  color: ${p => p.theme.palette.colors.text};
  font-size: 16px;
  overflow-wrap: anywhere;
`

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;

  @media(max-width: 560px) {
    align-items: stretch;
    flex-direction: column-reverse;

    & > * { width: 100%; }
  }
`

export const DecisionCopy = styled.p`
  max-width: 720px;
  margin: 0 0 20px;
  color: ${p => p.theme.palette.colors.muted};
  line-height: 1.6;
`

export const ConfirmationPanel = styled.div`
  margin-top: 22px;
  padding: 20px;
  border: 1px solid ${p => p.status === 'approve' ? p.theme.palette.success.main : p.theme.palette.error.main};
  border-radius: 14px;
  background: ${p => p.status === 'approve' ? p.theme.palette.colors.successMuted : p.theme.palette.colors.warningMuted};
  color: ${p => p.theme.palette.colors.muted};

  strong, span { display: block; }
  strong { margin-bottom: 7px; color: ${p => p.theme.palette.colors.text}; font-size: 18px; }
  span { line-height: 1.55; }
`

export const OutcomeBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px;
  border: 1px solid ${p => p.status === 'approved' ? p.theme.palette.success.main : p.theme.palette.error.main};
  border-radius: 14px;
  background: ${p => p.status === 'approved' ? p.theme.palette.colors.successMuted : p.theme.palette.colors.warningMuted};
  color: ${p => p.theme.palette.colors.muted};

  strong { color: ${p => p.theme.palette.colors.text}; font-size: 19px; }
  span { line-height: 1.55; }
`

export const ErrorState = styled.section`
  max-width: 760px;
  margin: 0 auto;
  padding: 32px;
  border-radius: 18px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
`
